export default __webpack_public_path__ + "static/media/tempature.adb8fc98.png";